<template>
  <div v-if="pageInfo" class="page">
    <div class="header">油站提供什么？</div>
    <div v-for="(preview, i) in pageInfo.applyInfoList" :key="i">
      <div class="station_name">{{ preview.gasName }}</div>
      <div class="discount_outer">
        <div class="discount_wrap" v-for="(item, index) in preview.oilPriceEffectTimeList" :key="index">
          <div class="top_info">生效时间：{{ item.effectTimeStr }}</div>
          <div class="discount_item" v-for="(subItem, subIndex) in preview.oilPriceList" :key="subIndex">
            <div class="main">
              <div class="num">{{ subItem.rebate }}</div>
              <div class="unit">{{ subItem.percent === 1 ? '%' : '元' }}</div>
            </div>
            <div class="desc">{{ subItem.oilName }}让利提升至</div>
          </div>
        </div>
      </div>
      <div v-if="preview.memberDayList && preview.memberDayList.length" class="other_outer">
        <div class="label">会员日让利：</div>
        <div class="other_wrap">
          <div v-for="(subItem, subIndex) in preview.memberDayList" :key="subIndex" class="other_item">
            <div class="title">{{ subItem.oilName }} 让利提升至{{ subItem.rebate }}{{ subItem.percent === 1 ? '%' : '元' }}</div>
            <div v-for="(thirdItem, thirdIndex) in subItem.effectTimeList" :key="thirdIndex">
              <div class="desc">日期：{{ formatTime(thirdItem.timeType, thirdItem.weekday) }}</div>
              <div class="desc">时段：{{ thirdItem.clockTime || '全天' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="pageInfo.remark">
      <div class="header" style="margin-top: 24px;">油站得到什么？</div>
      <div class="benefit_list">
        <div class="benefit_item">
          <div class="title">
            <img src="https://web.nlktj.com/ty/merchant/persisMarket/activeDetail/gift.png" alt="" />
            <div>活动权益</div>
          </div>
          <div class="benefit_content">
            <div v-html="pageInfo.remark"></div>
          </div>
        </div>
      </div>
    </template>
    <div class="footer g-flex-c">
      <el-button v-if="isDetail" @click="handleBack">返回</el-button>
      <el-button v-else type="primary" @click="handleSubmit">立即参与</el-button>
    </div>
  </div>
</template>
<script>
import { queryLiaoyuanGasConfigList, liaoyuanSignup } from '@/api/marketPromotion'

export default {
  data () {
    return {
      pageInfo: null
    }
  },
  created () {
    this.getData()
  },
  computed: {
    isDetail () {
      return Number(this.$route.query.btnType) === 3
    }
  },
  methods: {
    async getData () {
      const { ruleId, btnType: signUpStatus } = this.$route.query
      const params = { ruleId, signUpStatus }
      const { code, result } = await queryLiaoyuanGasConfigList(params)
      if (code !== 200) return
      this.pageInfo = result
    },
    handleBack () {
      this.$router.go(-1)
    },
    async handleSubmit () {
      const applyIdStr = this.pageInfo.applyInfoList.map(item => item.id).join(',')
      const { code } = await liaoyuanSignup({ ruleId: this.$route.query.ruleId, signUpType: 1, applyIdStr })
      if (code === 200) {
        this.$message.success('报名成功')
        this.$router.push({
          path: '/promotion/centerShow'
        })
      }
    },
    // 格式化时间
    // timeType 时间类型 1-按日期 2-按星期
    // weekday 是一个字符串，例如：1,2,3,4,5,6,7
    formatTime (timeType, weekday) {
      const formatWeekday = weekday => {
        return weekday === '1' ? '周一' : weekday === '2' ? '周二' : weekday === '3' ? '周三' : weekday === '4' ? '周四' : weekday === '5' ? '周五' : weekday === '6' ? '周六' : weekday === '7' ? '周日' : ''
      }
      if (timeType === 2) {
        return weekday.split(',').map(item => formatWeekday(item)).join(',')
      }
      return weekday
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  background-color: #fff;
  margin-top: 30px;
  padding: 20px;
  padding-bottom: 120px;
  .header {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    &::before {
      content: '';
      background-image: url('../../../assets/image/icon/titleStart.png');
      background-size: 100% 100%;
      width: 24px;
      height: 24px;
      display: inline-block;
      margin-right: 5px;
      vertical-align: bottom;
    }
  }
  .station_name {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 24px;
    padding-left: 12px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      display: block;
      width: 4px;
      height: 18px;
      background: #4B7EFE;
      border-radius: 12px;
    }
  }
  .discount_outer {
    display: flex;
    align-items: center;
  }
  .discount_wrap {
    box-sizing: border-box;
    min-width: 284px;
    height: 118px;
    background: #4B7EFE;
    border-radius: 12px;
    color: #fff;
    padding: 0 4px;
    margin: 10px 16px 0 0;
    display: flex;
    align-items: center;
    position: relative;
    .top_info {
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.90);
      line-height: 20px;
      background: rgba(255, 255, 255, 0.10);
      border-radius: 0 12px;
      padding: 0 8px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .discount_item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0 20px;
      position: relative;
      .main {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .num {
          font-size: 32px;
          font-weight: 700;
          line-height: 24px;
        }
        .unit {
          font-size: 16px;
          font-weight: 700;
          line-height: 16px;
        }
      }
      .desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 6px;
        white-space: nowrap;
      }
      &+.discount_item {
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          display: block;
          width: 1px;
          height: 45px;
          background: rgba(255,255,255,.1);
        }
      }
    }
  }
  .benefit_list {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    .benefit_item {
      width: 100%;
      background-color: #fafcff;
      border: 1px solid #F1F1F6;
      border-radius: 12px;
      .title {
        width: 100%;
        height: 120px;
        background-image: url('https://weber-imgs-1304574412.cos.ap-beijing.myqcloud.com/ty/merchant/persisMarket/activeDetail/titleBackground.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
          margin-left: 20px;
        }
        div {
          font-size: 18px;
          color: #FF0000;
          font-weight: 600;
          margin-left: 10px;
        }
      }
      .benefit_content {
        padding: 20px 20px 0 20px;
        font-size: 14px;
        // font-weight: 600;
        // color: #666;
        &>div {
          margin-bottom: 25px;
        }
        .sub_content {
          margin-top: 10px;
          .light {
            color: #4B7EFE;
          }
        }
      }
    }
  }
  .tips_name {
    margin: 20px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .tips_list {
    font-size: 12px;
    color: #888;
    line-height: 18px;
  }
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 88px;
    text-align: center;
    background-color: #fff;
    border-top: 1px solid #fff;
    box-shadow: 0px -0.5px 0px 0px rgba(0, 0, 0, 0.12);
  }
  /deep/.el-button  {
    border-radius: 8px !important;
    margin-left: 100px;
  }
  .other_outer {
    box-sizing: border-box;
    width: 100%;
    background: #FFF9E5;
    border-radius: 12px;
    border: 0.5px solid #FFDE65;
    padding: 12px 24px;
    margin: 17px auto 24px;
    display: flex;
    .label {
      flex-shrink: 0;
      font-size: 16px;
      font-weight: 600;
      color: #735F15;
      line-height: 24px;
      white-space: nowrap;
      margin-right: 7px;
    }
    .other_wrap {
      flex: 1;
      display: flex;
      align-items: center;
      .other_item {
        max-width: 50%;
        box-sizing: border-box;
        padding-right: 40px;
        .title {
          font-size: 16px;
          font-weight: 600;
          color: #735F15;
          line-height: 20px;
        }
        .desc {
          font-size: 12px;
          font-weight: 400;
          color: rgba(115, 95, 21, 0.70);
          line-height: 20px;
        }
      }
    }
  }
}
</style>
